import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "EmployeeCalendarCountries",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const {
  getEmployeeCalendarCountries,
  getEmployeeCalendarCountriesError,
  getEmployeeCalendarCountriesSuccess,
} = slice.actions;

reducerRegistry.register("employeeCalendarCountries", reducer);
